const SubmitButton = ({ label, className = " ", handleClick, errors, values}) => {
    return(
        <div className={className}>
            <button
                type="button"
                onClick={(e)=> handleClick(values, errors, e)}
                className=" w-full inline-flex justify-center rounded-md border border-transparent bg-azulBrillanteMira py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-secundarioMira hover:border-azulBrillanteMira hover:border-2 focus:outline-none"
            >
                <div className="flex">
                    <p className="ml-1">{label}</p>
                </div>
            </button>
        </div>
    )
}

export default SubmitButton